import { useParams } from "react-router-dom"
import { assertIsDefined } from "@/utils/assetIsDefined"

export const useApprovalRequestIdFromParams = () => {
    const { approvalRequestId } = useParams<{ approvalRequestId: string }>()
    assertIsDefined(approvalRequestId)

    return { approvalRequestId }
}
